import { Anchor, Divider, Group, Stack, Text } from '@mantine/core';
import { IconArrowUpRight } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { claimTotal, encounterSubtotal, type ClaimEncounter, type ClaimRow } from '../mockClaims';
import { formatCurrency, formatDate } from './billingFormatters';

function ClaimEncounterBlock({ enc }: { enc: ClaimEncounter }): JSX.Element {
  return (
    <Stack gap="xs">
      <Group justify="space-between" wrap="nowrap" gap="sm">
        <Group gap="xs" wrap="nowrap" style={{ minWidth: 0 }}>
          <Text size="sm" fw={600}>
            {enc.encounterIdentifier}
          </Text>
          <Text size="xs" c="dimmed">
            {formatDate(enc.serviceDate)}
          </Text>
        </Group>
        <Anchor
          component={Link}
          to={`/dashboard/appointments/${enc.appointmentId}`}
          size="xs"
          fw={600}
          style={{ whiteSpace: 'nowrap' }}
        >
          <Group gap={2} wrap="nowrap">
            Appointment
            <IconArrowUpRight size={14} />
          </Group>
        </Anchor>
      </Group>
      <Stack gap={4} pl="sm">
        {enc.items.map((item, index) => (
          <Group key={`${item.code}-${index}`} justify="space-between" wrap="nowrap" gap="sm">
            <Group gap="xs" wrap="nowrap" style={{ minWidth: 0 }}>
              <Text size="sm" fw={600}>
                {item.code}
              </Text>
              <Text size="sm" c="dimmed" truncate>
                {item.description}
              </Text>
            </Group>
            <Text size="sm" c="dimmed" style={{ whiteSpace: 'nowrap' }}>
              {formatCurrency(item.net)}
            </Text>
          </Group>
        ))}
        <Group justify="flex-end" wrap="nowrap">
          <Text size="xs" c="dimmed">
            Encounter subtotal: {formatCurrency(encounterSubtotal(enc))}
          </Text>
        </Group>
      </Stack>
    </Stack>
  );
}

export function ClaimBreakdown({ claim }: { claim: ClaimRow }): JSX.Element {
  return (
    <Stack gap="md">
      <Group justify="space-between" wrap="nowrap">
        <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
          Encounters &amp; Line Items
        </Text>
        <Text size="sm" fw={700}>
          {formatCurrency(claimTotal(claim))}
        </Text>
      </Group>
      {claim.encounters.map((enc, index) => (
        <Stack key={enc.encounterIdentifier} gap="md">
          {index > 0 && <Divider variant="dashed" />}
          <ClaimEncounterBlock enc={enc} />
        </Stack>
      ))}
    </Stack>
  );
}
